"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBranch = addBranch;
exports.deleteBranch = deleteBranch;
exports.getBranchDetail = getBranchDetail;
exports.getBranchList = getBranchList;
exports.updateBranch = updateBranch;
var _request = _interopRequireDefault(require("@/utils/request"));
function getBranchList(params) {
  return (0, _request.default)({
    url: '/api/v1/branch',
    method: 'get',
    params: params
  });
}
function getBranchDetail(id) {
  return (0, _request.default)({
    url: '/api/v1/branch/' + id,
    method: 'get'
  });
}
function updateBranch(data) {
  return (0, _request.default)({
    url: '/api/v1/branch/' + data.id,
    method: 'patch',
    data: data
  });
}
function addBranch(data) {
  return (0, _request.default)({
    url: '/api/v1/branch',
    method: 'post',
    data: data
  });
}
function deleteBranch(id) {
  return (0, _request.default)({
    url: '/api/v1/branch/' + id,
    method: 'delete'
  });
}